import { MEDIA_NOW_PREFIX, MEDIA_NOW_SUFFIX } from './videoUrlComm';

export const ALLETRAMP_VIDEO_URL = Object.freeze({
  CLOUD_ENABLE_STEP3:
    MEDIA_NOW_PREFIX + 'PLMSJJGLJG&ek=tySgXCKm' + MEDIA_NOW_SUFFIX,
  CLOUD_ENABLE_STEP4:
    MEDIA_NOW_PREFIX + 'ONOJPMLKFM&ek=SdCUEnU9' + MEDIA_NOW_SUFFIX,
  CLOUD_ENABLE_STEP5:
    MEDIA_NOW_PREFIX + 'RQJSJODMJK&ek=erxR1u34' + MEDIA_NOW_SUFFIX,
  CLOUD_ENABLE_STEP6:
    MEDIA_NOW_PREFIX + 'OJPQMLJFHF&ek=eP3Cq7ex' + MEDIA_NOW_SUFFIX,
  CLOUD_ENABLE_STEP6_SUBSCRIBED:
    MEDIA_NOW_PREFIX + 'RPSPRJEMJL&ek=2V1Bp976' + MEDIA_NOW_SUFFIX,
  CLOUD_ENABLE_SDS_AWS_STEP3:
    MEDIA_NOW_PREFIX + 'PLMSJJGLJG&ek=QIsFCHjs' + MEDIA_NOW_SUFFIX,
  CLOUD_ENABLE_SDS_AWS_STEP4:
    MEDIA_NOW_PREFIX + 'ONOJPMLKFM&ek=4Z8yNauc' + MEDIA_NOW_SUFFIX,
  CLOUD_ENABLE_SDS_AWS_STEP5:
    MEDIA_NOW_PREFIX + 'RQJSJODMJK&ek=4UZZ5BZx' + MEDIA_NOW_SUFFIX,
  CLOUD_ENABLE_SDS_AWS_STEP6:
    MEDIA_NOW_PREFIX + 'OJPQMLJFHF&ek=0qsc3gvO' + MEDIA_NOW_SUFFIX,

  FACTORY_UNBOX_STEP1:
    MEDIA_NOW_PREFIX + 'OQNMQRFMKK&ek=SNkCp1Zb' + MEDIA_NOW_SUFFIX,
  FACTORY_UNBOX_STEP2:
    MEDIA_NOW_PREFIX + 'SSQPQMDFFI&ek=wpf0U1M0' + MEDIA_NOW_SUFFIX,
  FACTORY_UNBOX_STEP3:
    MEDIA_NOW_PREFIX + 'LLLJMRHDDG&ek=QABZcMVy' + MEDIA_NOW_SUFFIX,

  FIELD_UNBOX: MEDIA_NOW_PREFIX + 'ROJNPLKJLD&ek=CBHbNXRH' + MEDIA_NOW_SUFFIX,
  UNBOX_ALLETRAMPX10000:
    MEDIA_NOW_PREFIX + 'RSJSSOGMGG&ek=sl8BfeFT' + MEDIA_NOW_SUFFIX,
  RACK_ALLETRAMPX10000_STEP1:
    MEDIA_NOW_PREFIX + 'QJJNORLDKD&ek=aaOkUjSf' + MEDIA_NOW_SUFFIX,
  RACK_ALLETRAMPX10000_STEP2:
    MEDIA_NOW_PREFIX + 'NMOMPJHGKK&ek=s3Yr5IaF' + MEDIA_NOW_SUFFIX,
  RACK_ALLETRAMPX10000_STEP3:
    MEDIA_NOW_PREFIX + 'RSOKKMFDGJ&ek=DMHqyjvA' + MEDIA_NOW_SUFFIX,
  RACK_ALLETRAMPX10000_STEP4:
    MEDIA_NOW_PREFIX + 'MJSRLOMIFI&ek=Sw1SW9yY' + MEDIA_NOW_SUFFIX,
  CABLE_ALLETRAMPX10000_STEP1:
    MEDIA_NOW_PREFIX + 'SSNRNQJJMJ&ek=MhzigHiJ' + MEDIA_NOW_SUFFIX,
  CABLE_ALLETRAMPX10000_STEP2:
    MEDIA_NOW_PREFIX + 'MOPNKLGHGM&ek=oGAxm1e3' + MEDIA_NOW_SUFFIX,
  CABLE_ALLETRAMPX10000_STEP3:
    MEDIA_NOW_PREFIX + 'KSQKMOLGHJ&ek=CXZywMAr' + MEDIA_NOW_SUFFIX,
  CABLE_ALLETRAMPX10000_STEP4:
    MEDIA_NOW_PREFIX + 'KNKJOSHILE&ek=tx7y7oCE' + MEDIA_NOW_SUFFIX,
  POWERON_ALLETRAMPX10000:
    MEDIA_NOW_PREFIX + 'LRSNMSLHJD&ek=6HWqJFuw' + MEDIA_NOW_SUFFIX,
  CONNECT_ALLETRAMPX10000:
    MEDIA_NOW_PREFIX + 'RJRNNKJMME&ek=WiJXcQ54' + MEDIA_NOW_SUFFIX,
  CONNECT_ALLETRAMPX10000_WIZARDDISCOVERYTOOL:
    MEDIA_NOW_PREFIX + 'LRMPOSEKFF&ek=esIyJAAg' + MEDIA_NOW_SUFFIX,
  SETUP_ALLETRAMPX10000:
    MEDIA_NOW_PREFIX + 'NOORPLGJLI&ek=O4jkFHGt' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_STEP1:
    MEDIA_NOW_PREFIX + 'QSKKQJGDID&ek=ROtkcj0n' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_STEP2:
    MEDIA_NOW_PREFIX + 'RKRRNMIIIJ&ek=kvJt2EOT' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_STEP3:
    MEDIA_NOW_PREFIX + 'NQMMKNIMJI&ek=VDnc9NSz' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_STEP4:
    MEDIA_NOW_PREFIX + 'MOORPLFEDJ&ek=KznNKJcb' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_SWITCHED_STEP5:
    MEDIA_NOW_PREFIX + 'QJRLMPIFFH&ek=Cxw13G9z' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_SWITCHED_STEP6:
    MEDIA_NOW_PREFIX + 'MLSOSJEIJL&ek=7VEuNUzK' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_STEP1:
    MEDIA_NOW_PREFIX + 'MJQOOOIIJH&ek=vh5tgaRV' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_STEP2:
    MEDIA_NOW_PREFIX + 'OJRMSJKFIG&ek=QKwXKemo' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_STEP3:
    MEDIA_NOW_PREFIX + 'NLPJSOHEMD&ek=yFbQ2TLL' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_STEP4:
    MEDIA_NOW_PREFIX + 'MJOSONFEHD&ek=MFhqoJ4I' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_SWITCHED_STEP2:
    MEDIA_NOW_PREFIX + 'NJPOSPHHIM&ek=TNWL2Nh3' + MEDIA_NOW_SUFFIX,
  FIELD_CABLE_DIRECTATTACHED_STEP2:
    MEDIA_NOW_PREFIX + 'KKRPLOHEEF&ek=skVnfn1n' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_DIRECTATTACHED_PHYSICAL_STEP4:
    MEDIA_NOW_PREFIX + 'NQMMKNIMJI&ek=aRY5frbD' + MEDIA_NOW_SUFFIX,
  FIELD_INSTALL_DIRECTATTACHED_PHYSICAL_STEP5:
    MEDIA_NOW_PREFIX + 'MOORPLFEDJ&ek=rzrgN8Cj' + MEDIA_NOW_SUFFIX,
  POWERUPANDINIT:
    MEDIA_NOW_PREFIX + 'NQQKRMDFML&ek=BfVw6mGJ' + MEDIA_NOW_SUFFIX,
  DISCOVER_ARRAY:
    MEDIA_NOW_PREFIX + 'KSOLSOLILK&ek=HUStUGng' + MEDIA_NOW_SUFFIX,
  CONNECT_ARRAY: MEDIA_NOW_PREFIX + 'OOJJNOMGFL&ek=bJRS0han' + MEDIA_NOW_SUFFIX,
  CONNECT_ARRAY_PHYSICAL:
    MEDIA_NOW_PREFIX + 'OOJJNOMGFL&ek=6VmgWiFw' + MEDIA_NOW_SUFFIX,
  CONNECT_ARRAY_BLUETOOTH:
    MEDIA_NOW_PREFIX + 'PJMMPPHGGE&ek=qyGGIlx7' + MEDIA_NOW_SUFFIX,
  CONNECT_ARRAY_BLUETOOTH_SWITCHED:
    MEDIA_NOW_PREFIX + 'PJMMPPHGGE&ek=BfGSw0PX' + MEDIA_NOW_SUFFIX,
  SETUP_ARRAY: MEDIA_NOW_PREFIX + 'SKOLOQMEGI&ek=g5YdqJgD' + MEDIA_NOW_SUFFIX,
  CONFIGURE_INSTALLATION:
    MEDIA_NOW_PREFIX + 'OMQMMOFIDD&ek=DNWw8PD3' + MEDIA_NOW_SUFFIX,
});
